import Vue from 'vue'
import store from '@/store'

export default {
  getSessionFromVueSession() {
    const sessionUser = Vue.prototype.$session?.get('cas_user')
    return sessionUser?.role || null
  },
  getSessionFromLocalStorage() {
    const userData = localStorage.getItem('userData')
    if (userData) {
      try {
        const parsedUserData = JSON.parse(userData)
        return parsedUserData?.role || null
      } catch (error) {
        console.error('Error parsing userData from localStorage:', error)
        return null
      }
    }
    return null
  },
  getUserRole() {
    // Obtenemos de vue-session la información del usuario esto funciona cuando se recarga la pagina o se mueve a otra pagina
    const sessionRole = this.getSessionFromVueSession()
    if (sessionRole) return sessionRole
    // Obtenemos del localStorage la información del usuario esto funciona cuando se abre una nueva pestaña
    const localStorageRole = this.getSessionFromLocalStorage()
    if (localStorageRole) return localStorageRole
    return null
  },
  getProfilesView() {
    return store.getters.getProfilesView
  },
  checkPermission (obj = {}, permission) {
    if (!obj || typeof obj !== 'object') return undefined
    return permission in obj ? obj[permission] === true : undefined
  },
  hasRolePermission({ permission, module, section}) {
    if (!permission) return false
    const profilesView = this.getProfilesView()
    const moduleFound = profilesView.permission_modules?.find(m => m.module === module)
    const modulePermissions = moduleFound?.permissions || {}

    return this.checkPermission(modulePermissions[section], permission)
  },
  hasPermissionOrFallback({ permission, module, section, fallbackRoles = [], allRoles = false}) {
    const hasPermission = this.hasRolePermission({ permission, module, section })
    if (hasPermission === true) return true
    if (hasPermission === undefined) {
      if (allRoles) return true
      const userRole = this.getUserRole()
      return fallbackRoles.includes(userRole)
    }
    return false
  }
}